import { IEditorItemConfig } from 'ngx-lib';
import { EntityCustomFieldValueView } from '../services/http/clients/api-proxies';

export type ICardConfig = Record<number, IEditorItemConfig[]>;

export function customFieldPlacement(
    cardsConfig: ICardConfig,
    customField: EntityCustomFieldValueView,
    defaultPlacement: number,
    isReadOnly: boolean
) {
    const cardSection = cardsConfig[customField.entityTypeCustomFieldSectionId || defaultPlacement];

    const customFieldIndex = cardSection.findIndex(
        (el) =>
            (el.bindContext as EntityCustomFieldValueView).entityTypeCustomFieldId ===
            customField.entityTypeCustomFieldId
    );
    if (customFieldIndex > -1) return;

    cardSection.push({
        label: customField.name,
        componentId: customField.editor,
        bindContext: customField,
        fieldName: 'rawValue',
        isReadOnly: isReadOnly,
        additionalInfo: {
            options: customField.options
        }
    } as IEditorItemConfig);
}
